"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Revieve = void 0;
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _Loading = require("../Loading");
var _Restore = require("../Restore");
var _constants2 = require("./constants");
var _hooks2 = require("./hooks");
var _jsxRuntime = require("react/jsx-runtime");
const Revieve = props => {
  const {
    close,
    continueToPdp,
    initConfig,
    onInit,
    open,
    reset,
    state
  } = (0, _hooks2.useRevieve)(props);
  (0, _hooks.useRevieveScript)({
    initConfig,
    onInit
  });
  (0, _hooks.useOnHrefClick)({
    href: _constants.OPEN_HREF_ATTRIBUTE,
    onClick: open
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {
      show: state === _constants2.STATE_LOADING
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Restore.Restore, {
      show: state === _constants2.STATE_RESTORED,
      onClose: close,
      onContinue: continueToPdp,
      onReset: reset
    })]
  });
};
exports.Revieve = Revieve;
